import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { categories } from "@/mocks/articles";
import { siteInfo } from "@/mocks/site";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 80);
    };
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
    setDropdownOpen(false);
  }, [location.pathname]);

  const isHome = location.pathname === "/";

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isHome && !scrolled
          ? "bg-transparent"
          : "bg-background-50 border-b border-background-200/70"
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link
            to="/"
            className={`text-lg font-bold whitespace-nowrap transition-colors ${
              isHome && !scrolled ? "text-white" : "text-foreground-950"
            }`}
          >
            {siteInfo.name}
          </Link>

          <div className="hidden md:flex items-center gap-8">
            <Link
              to="/"
              className={`text-sm font-medium transition-colors hover:text-primary-500 whitespace-nowrap ${
                isHome && !scrolled ? "text-white/90" : "text-foreground-700"
              } ${location.pathname === "/" ? (isHome && !scrolled ? "text-white" : "text-primary-500") : ""}`}
            >
              首页
            </Link>

            <div
              className="relative"
              onMouseEnter={() => setDropdownOpen(true)}
              onMouseLeave={() => setDropdownOpen(false)}
            >
              <button
                className={`flex items-center gap-1 text-sm font-medium transition-colors hover:text-primary-500 whitespace-nowrap ${
                  isHome && !scrolled ? "text-white/90" : "text-foreground-700"
                } ${
                  location.pathname.startsWith("/category")
                    ? isHome && !scrolled
                      ? "text-white"
                      : "text-primary-500"
                    : ""
                }`}
              >
                分类浏览
                <i
                  className={`ri-arrow-down-s-line transition-transform duration-200 ${
                    dropdownOpen ? "rotate-180" : ""
                  }`}
                ></i>
              </button>
              {dropdownOpen && (
                <div className="absolute top-full left-1/2 -translate-x-1/2 pt-2">
                  <div className="bg-background-50 border border-background-200/70 rounded-lg py-2 min-w-[180px] shadow-sm">
                    {categories.map((cat) => (
                      <Link
                        key={cat.slug}
                        to={`/category/${cat.slug}`}
                        className="block px-4 py-2.5 text-sm text-foreground-700 hover:bg-background-100 hover:text-primary-500 transition-colors whitespace-nowrap"
                      >
                        {cat.name}
                      </Link>
                    ))}
                  </div>
                </div>
              )}
            </div>

            <Link
              to="/about"
              className={`text-sm font-medium transition-colors hover:text-primary-500 whitespace-nowrap ${
                isHome && !scrolled ? "text-white/90" : "text-foreground-700"
              } ${location.pathname === "/about" ? (isHome && !scrolled ? "text-white" : "text-primary-500") : ""}`}
            >
              关于我们
            </Link>
          </div>

          <button
            className={`md:hidden w-8 h-8 flex items-center justify-center ${
              isHome && !scrolled ? "text-white" : "text-foreground-950"
            }`}
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="菜单"
          >
            <i className={`${mobileOpen ? "ri-close-line" : "ri-menu-line"} text-xl`}></i>
          </button>
        </div>

        {mobileOpen && (
          <div className="md:hidden border-t border-background-200/70 py-4 bg-background-50">
            <div className="flex flex-col gap-3">
              <Link
                to="/"
                className={`text-sm font-medium px-2 py-1.5 rounded transition-colors ${
                  location.pathname === "/" ? "text-primary-500 bg-primary-100/50" : "text-foreground-700 hover:text-primary-500"
                }`}
              >
                首页
              </Link>
              <div className="text-sm font-medium px-2 py-1.5 text-foreground-500">
                分类浏览
              </div>
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className={`text-sm pl-6 py-1.5 rounded transition-colors ${
                    location.pathname === `/category/${cat.slug}`
                      ? "text-primary-500 bg-primary-100/50"
                      : "text-foreground-700 hover:text-primary-500"
                  }`}
                >
                  {cat.name}
                </Link>
              ))}
              <Link
                to="/about"
                className={`text-sm font-medium px-2 py-1.5 rounded transition-colors ${
                  location.pathname === "/about" ? "text-primary-500 bg-primary-100/50" : "text-foreground-700 hover:text-primary-500"
                }`}
              >
                关于我们
              </Link>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}